import Image from "next/image";
import { useRouter } from "next/router";
import styles from "./proprietyCard.module.css";

export default function ProprietyCard({ data }) {
  const router = useRouter();
  return (
    <div
      className={styles.proprietyContainer}
      onClick={() => router.push(`/imovel/${data.slug}`)}
    >
      {data.imagemCard && (
        <Image
          loading="lazy"
          className={styles.proprietyImg}
          src={data.imagemCard.url}
          width={data.imagemCard.width}
          height={data.imagemCard.height}
          alt={data.nome}
          objectFit="fill"
          layout="responsive"
          objectPosition="center"
        />
      )}
      <div className={styles.proprietyText}>
        <div className={styles.phaseCity}>
          <div
            className={styles.parallelogramSpan}
            style={{ background: data.etapasImovel && data.etapasImovel.cor }}
          >
            <span>{data.etapasImovel && data.etapasImovel.etapa}</span>
          </div>
          <span>{data.cidades.cidade}</span>
          <span>-</span>
          <span>{data.cidades.uf}</span>
        </div>
        <span style={{ fontSize: 25, fontWeight: 500 }}>{data.nome}</span>
        <div className={styles.typologyDesc}>
          <span>{data.tipologia}</span>
          <span>{data.descricao}</span>
        </div>
      </div>
    </div>
  );
}
